import React, { useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import axios from 'axios';
import Config from '../../API/Config';

const { TextArea } = Input;

const NewNoteModal = ({ visible, onClose, onNoteAdded }) => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const agentId = JSON.parse(localStorage.getItem("userData"))?.id;

    if (!title || !content) {
      return message.warning("Please enter both title and content.");
    }

    setSaving(true);
    try {
      const response = await axios.post(`${Config.baseURL}/notes/newnote`, {
        title,
        content,
        agentId
      });

      if (response.data.status) {
        message.success("Note saved successfully!");
        onNoteAdded(); // refresh notes
        onClose();
        setTitle('');
        setContent('');
      } else {
        message.error("Failed to save note.");
      }
    } catch (err) {
      console.error(err);
      message.error("Error saving note.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      title="Add New Note"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="save" type="primary" loading={saving} onClick={handleSave}>
          Save
        </Button>
      ]}
    >
      <Input
        placeholder="Note title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={{ marginBottom: 10 }}
      />
      <TextArea
        placeholder="Note content"
        rows={5}
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />
    </Modal>
  );
};

export default NewNoteModal;
